import { createFileRoute } from "@tanstack/react-router";
import BrandPage from "@/pages/BrandPage";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product-intech-rv/")({
  head: () => pageHead({ title: 'inTech RVs', description: 'Shop inTech RVs at Rex & Sons RVs in Castle Hayne, NC.', path: '/product-intech-rv' }),
  component: BrandPage,
});